export const OPERATORS = {
  ON_OR_BEFORE: "On or Before",
  ON_OR_AFTER: "On or After",
};

export const generateQueryUrl = (url, tokens = []) => {
  if (!tokens.length) return url;

  let queryUrl = `${url}?`;
  tokens.forEach((token, index) => {
    const lastElement = index === tokens.length - 1;
    const category = token.category.value;
    const operator = token.operator;
    const value = token.value.value;

    if (typeof value === "string") {
      let suffix;
      if (operator === "contains") {
        suffix = "icontains=";
      } else if (operator === OPERATORS.ON_OR_AFTER) {
        suffix = "gte=";
      } else if (operator === OPERATORS.ON_OR_BEFORE) {
        suffix = "lte=";
      } else {
        suffix = `iexact${operator}`;
      }
      queryUrl = `${queryUrl}${category}__${suffix}${value}${!lastElement ? "&" : ""}`;
    } else {
      // boolean value
      queryUrl = `${queryUrl}${category}${operator}${value}${!lastElement ? "&" : ""}`;
    }
  });

  return queryUrl;
};
